console.info(`[Aprobatica]
├── [INIT] Team members:
│   ├── Vladimir Kurochkin    → tachyon@aprobatica.com
│   ├── Anatoliy Nedospasov   → naastrr@gmail.com
│   ├── Polina Tkachuk        → polina01tk@gmail.com
│   ├── Nikita Zabusov        → kitanit-baz@yandex.ru
│   ├── Pavel Laptev          → kvaitolink@yandex.ru
│   ├── Elizaveta Sokha       → el.sokha28@gmail.com
│   └── Sergey Dultsev        → dultsev010904@gmail.com
└── [DONE] 7 members verified.`);

import Vue, { createApp } from 'vue';
import App from './UI/TheApp.vue';
import { createPinia } from 'pinia';
import ShareNetwork from './share/sharing';
import './UI/styles/index.css';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { PiniaUndo } from 'pinia-undo';
import router from './router';
import TheMask from 'vue-the-mask';

// Vue.config.productionTip = false
const pinia = createPinia();
const app = createApp(App);
app.use(TheMask);
app.use(router);
pinia.use(PiniaUndo);
// pinia.use(piniaPluginPersistedstate);
app.use(pinia);
app.use(ShareNetwork);
app.mount('#configurator-app');
